// Unit Messages Management Permissions

export const UNIT_MESSAGES_INDEX = 21;
export const UNIT_MESSAGES_CHANGE_READ_STATE = 22;
export const UNIT_MESSAGES_DELETE = 23;
export const UNIT_MESSAGES_UPDATE_STATUS = 1216;
